var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(-715 -566) translate(715 452) translate(0 114)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#32325D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.429 7.778v1.11c0 .615-.512 1.112-1.143 1.112H1.143C.512 10 0 9.503 0 8.889V1.11C0 .497.512 0 1.143 0h5.143c.63 0 1.143.497 1.143 1.111v1.111H6.286v-1.11H1.143v7.777h5.143V7.778h1.143zm1.428-5.834l-.808.786 1.764 1.714H4v1.112h5.813L8.049 7.27l.808.786L12 5 8.857 1.944z",
    transform: "translate(-715 -566) translate(715 452) translate(0 114) translate(2 3)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.040e2f24180e199ae59cf2a5b1953097.svg";
export { ForwardRef as ReactComponent };